import { render, staticRenderFns } from "./KimsaTextFieldWithSelect.vue?vue&type=template&id=4df8bec0&scoped=true&"
import script from "./KimsaTextFieldWithSelect.vue?vue&type=script&lang=js&"
export * from "./KimsaTextFieldWithSelect.vue?vue&type=script&lang=js&"
import style0 from "./KimsaTextFieldWithSelect.vue?vue&type=style&index=0&id=4df8bec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df8bec0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
